// utils/mpApi.js
// Cliente del back Mercado Pago (manageIntegrations).
import axios from "axios";
import { MP_CONFIG } from "../Config/config-env.js";

// El tenant elevax viaja en el header x-organization-id.
function orgHeaders(org) {
  return { "x-organization-id": org };
}

// Crea la preference (Checkout Pro) para una orden elevax y devuelve el init_point.
// `email` es obligatorio — el back valida que coincida con el dueño de la orden.
export async function createMpPreference(org, orderId, email) {
  try {
    const { data } = await axios.post(
      `${MP_CONFIG.base_url}/create-preference`,
      { orderId, email },
      { headers: orgHeaders(org) }
    );
    return data; // { status, initPoint, sandboxInitPoint, amount, currency, ... }
  } catch (e) {
    return (
      e?.response?.data || {
        status: false,
        message: e.message || "Error creando preferencia",
      }
    );
  }
}

// Consulta el estado de un pago (polling en las páginas de resultado).
// `org` viaja como header — el back lo necesita para leer el token del tenant.
export async function getMpStatus(paymentId, org) {
  try {
    const { data } = await axios.get(`${MP_CONFIG.base_url}/status`, {
      params: { payment_id: paymentId },
      headers: org ? orgHeaders(org) : undefined,
    });
    return data; // { status, paymentStatus, orderId, ... }
  } catch (e) {
    return (
      e?.response?.data || {
        status: false,
        message: e.message || "Error consultando pago",
      }
    );
  }
}
